import {
  useEffect,
  useRef,
  useState,
} from "react";

export const useTimer = (
  remainingTime?: number | null,
  hasTestTimeout?: boolean,
  dataReceivedAt?: number,
) => {
  const [ timer, setTimer ] = useState<number | null>(null);
  const startTimeRef = useRef<number | null>(null);
  const remainingTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (!dataReceivedAt) return;
    if (!hasTestTimeout) return;

    const normalizedRemainingTime = Math.max(0, remainingTime ?? 0);

    if (normalizedRemainingTime === 0) {
      setTimer(0);
      return;
    }

    const timePassed = Math.floor((Date.now() - dataReceivedAt) / 1000);
    const adjustedRemainingTime = Math.max(0, normalizedRemainingTime - timePassed);

    startTimeRef.current = Date.now();
    remainingTimeRef.current = adjustedRemainingTime;
    setTimer(adjustedRemainingTime);

    const interval = setInterval(() => {
      if (startTimeRef.current === null || remainingTimeRef.current === null) return;

      const elapsedSeconds = Math.floor((Date.now() - startTimeRef.current) / 1000);
      const currentTime = remainingTimeRef.current - elapsedSeconds;

      if (currentTime <= 0) {
        clearInterval(interval);
        setTimer(0);
      } else {
        setTimer(currentTime);
      }
    }, 1000);

    return () => clearInterval(interval);

  }, [
    remainingTime,
    dataReceivedAt,
    hasTestTimeout,
  ]);

  return timer;
};
